export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="12" fill="#121215" stroke="#27272a" />
    <path d="M14 50 L44 20" stroke="#e2d9cc" strokeWidth="4" strokeLinecap="round" />
    <path d="M44 20 L50 14 L46 18 Z" fill="#e03131" />
    <circle cx="47" cy="17" r="3.4" fill="none" stroke="#e2d9cc" strokeWidth="2.4" />
    <path d="M18 46 C22 38 28 34 34 32 C30 38 26 44 24 50 Z" fill="#e03131" />
    <circle cx="16" cy="52" r="2.2" fill="#e2d9cc" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="nav-logo">
    <LogoMark size={compact ? 32 : 38} />
    <div className="leading-none">
      <span className="font-display font-black text-lg tracking-wide block">DUDU</span>
      <span className="font-mono-dt text-[10px] tracking-[0.35em] text-[#e03131] uppercase">Tattoo</span>
    </div>
  </div>
);
